"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Delete = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21.2 4.2V3a.6.6 0 00-.6-.6h-5.4V1.2A1.2 1.2 0 0014 0H9.2A1.2 1.2 0 008 1.2v1.2H2.6A.6.6 0 002 3v1.2a.6.6 0 00.6.6h18a.6.6 0 00.6-.6zM6.644 24a2.4 2.4 0 01-2.4-2.232L3.2 7.2H20l-1.02 14.568A2.4 2.4 0 0116.58 24H6.644z", clipRule: "evenodd" })); };
exports.Delete = Delete;
//# sourceMappingURL=delete.js.map